// src/pages/Estoque.js

import React from "react";
import AdminLayout from "../components/AdminLayout";
import DataTableEstoqueItens from "../components/DataTableEstoqueItens";

function EstoqueItens() {

  return (
    <AdminLayout>
      <DataTableEstoqueItens title="Itens Cadastrados" 
      excelButtonRoute={`${process.env.REACT_APP_API_BASE_URL}estoque/export/`} 
      pdfButtonRoute={`${process.env.REACT_APP_API_BASE_URL}estoque/export/pdf/`} />
    </AdminLayout>
  );
}

export default EstoqueItens;